var React = require('react');

function ScInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28 0V9H9V140H28V149H0V0H28Z","fill":"black","key":0}),React.createElement("path",{"d":"M84 48H65V66H84V48Z","fill":"black","key":1}),React.createElement("path",{"d":"M84 98H65V116H84V98Z","fill":"black","key":2}),React.createElement("path",{"d":"M121 9V0H149V149H121V140H140V9H121Z","fill":"black","key":3})]);
}

ScInline.defaultProps = {"width":"149","height":"149","viewBox":"0 0 149 149","fill":"none"};

module.exports = ScInline;

ScInline.default = ScInline;
